import { z } from 'zod';

export const mlsFormSchema = z.object({
  name: z.string().trim().min(1, 'MLS name is required'),
  boardCode: z.string().trim().min(1, 'Board code is required'),
  logo: z.string().trim().optional(),
  complianceText: z.string().trim().min(1, 'Compliance text is required'),
  agentId: z.array(z.string()).optional(),
  officeId: z.array(z.string()).optional(),
});

export type MLSFormData = z.infer<typeof mlsFormSchema>;
